import {
  EXPORT_ROWS_PER_STATUS,
  MAX_LENGTH_TO_DOWNLOAD,
} from 'config/workdesk-load';
import { alertsActions } from '.';
import getErrorMessage from 'utils/getErrorMessage';
import { downloadConstants } from 'store/constants';
import { EachWorkdeskTicketI } from 'store/models/workdesk-tickets/each-workdesk-ticket.interface';
import { Statuses } from 'store/models/Statuses';
import {
  MAX_LENGTH_TO_DOWNLOAD_PER_STATUS,
  WorkdeskTickets,
} from 'store/models/workdesk-tickets/WorkdeskTickets';
import { workdeskFilterWithPrevSelector } from 'store/selectors/workdesk-filter.selector';
import { workdeskTicketsService } from 'store/services/workdesk-tickets.service';
import { LoadWorkdeskTicketsParams } from 'store/models/workdesk-tickets/workdesk-tickets.interface';

const _request = (params: LoadWorkdeskTicketsParams) => {
  return {
    type: downloadConstants.LOAD_CSV_TICKETS_REQUEST,
    payload: {
      params,
    },
  };
};
const _failure = (error: string) => {
  return {
    type: downloadConstants.LOAD_CSV_TICKETS_ERROR,
    payload: {
      error,
    },
  };
};
// TODO: check type EachWorkdeskTicket
const _success = (tickets: EachWorkdeskTicketI[]) => {
  const beforeDedupN = tickets.length;
  const deduplicated = WorkdeskTickets.deduplicate(tickets);
  const afterDedupN = deduplicated.length;
  if (afterDedupN < beforeDedupN) {
    console.warn(
      `found ${afterDedupN - beforeDedupN} duplicate ticketIds `,
    );
  }
  return {
    type: downloadConstants.LOAD_CSV_TICKETS_SUCCESS,
    payload: {
      tickets,
    },
  };
};

const _loadAndFormatForParams = async (params): Promise<any[]> => {
  let data = await workdeskTicketsService.loadWorkdeskTickets(params);

  const formatted = WorkdeskTickets.formatTicketsDataForDownload(
    data.tickets,
    data.assigneeInfo,
  );
  return formatted;
};

const loadAllStatusesCsvWorkdeskTickets = () => {
  return async (dispatch, getState) => {
    const wdFilterWithPrev = workdeskFilterWithPrevSelector(
      getState(),
    );
    let params = WorkdeskTickets.workdeskFilterToLoadParams(
      wdFilterWithPrev,
    ) as LoadWorkdeskTicketsParams;
    try {
      let allResults = [] as EachWorkdeskTicketI[];
      for (let status of Statuses.mainStatuses) {
        params = {
          ...params,
          status,
          startAt: 0,
          rowsPerPage: EXPORT_ROWS_PER_STATUS,
        };
        let statusAllTicketsLength = 0;
        let statusTicketsLength = 0;
        let roundTickets = [] as any[];
        do {
          dispatch(_request(params));
          let formatted = await _loadAndFormatForParams(params);
          statusTicketsLength = formatted.length;
          statusAllTicketsLength += statusTicketsLength;
          params = { ...params, startAt: statusAllTicketsLength };

          roundTickets = roundTickets.concat(formatted);
        } while (
          statusTicketsLength > 0 &&
          statusAllTicketsLength <= MAX_LENGTH_TO_DOWNLOAD_PER_STATUS
        );
        allResults = allResults.concat(roundTickets);
      }
      // reformat row number
      allResults = allResults.map((row, index) => ({
        ...row,
        rowNo: index + 1,
      }));

      dispatch(_success(allResults));
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      dispatch(_failure(errorMessage as string));
      dispatch(alertsActions.error(errorMessage));
    }
  };
};

const loadCurStatusCsvWorkdeskTickets = () => {
  return async (dispatch, getState) => {
    const wdFilterWithPrev = workdeskFilterWithPrevSelector(
      getState(),
    );
    let params = WorkdeskTickets.workdeskFilterToLoadParams(
      wdFilterWithPrev,
    ) as LoadWorkdeskTicketsParams;
    console.debug(`params: `, params);
    params = {
      ...params,
      startAt: 0,
      rowsPerPage: EXPORT_ROWS_PER_STATUS,
    };
    let allTicketsLength = 0;
    let ticketsLength = 0;
    let allTickets = [] as any[]; //TODO: revisit

    try {
      do {
        console.debug(`Current startAt: ${params.startAt}`);
        dispatch(_request(params));
        let formatted = await _loadAndFormatForParams(params);
        ticketsLength = formatted.length;
        allTicketsLength += ticketsLength;
        params = { ...params, startAt: allTicketsLength };

        allTickets = allTickets.concat(formatted);
      } while (
        ticketsLength > 0 &&
        allTicketsLength <= MAX_LENGTH_TO_DOWNLOAD
      );
      // reformat row number
      allTickets = allTickets.map((row, index) => ({
        ...row,
        rowNo: index + 1,
      }));
      dispatch(_success(allTickets));
    } catch (error) {
      const errorMessage = getErrorMessage(error);

      dispatch(_failure(errorMessage as string));
      dispatch(alertsActions.error(errorMessage));
    }
  };
};

export const downloadActions = {
  loadCurStatusCsvWorkdeskTickets,
  loadAllStatusesCsvWorkdeskTickets,
};
